import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import AdapterMoment from "@material-ui/lab/AdapterMoment";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import configureStore from "redux/configureStore";
import StyledEngineProvider from "@material-ui/core/StyledEngineProvider";
import "moment/locale/fi.js";
import "./index.css";
import App from "./App";
import "locales/i18n";
import { PersistGate } from "redux-persist/integration/react";

export const { store, persistor } = configureStore();

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback="loading">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocalizationProvider dateAdapter={AdapterMoment} locale="fi">
            <StyledEngineProvider injectFirst>
              <App />
            </StyledEngineProvider>
          </LocalizationProvider>
        </PersistGate>
      </Provider>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
